import { FormActions } from '../FormActions'
import { FormHeader } from '../FormHeader'

function FormBody({
  Actions = FormActions,
  Component = 'div',
  Header = FormHeader,
  actionsProps,
  children,
  headerProps,
  ...formProps
}) {
  return (
    <Component {...formProps}>
      {Header ? <Header {...headerProps} /> : null}
      {children}
      {Actions ? <Actions {...actionsProps} /> : null}
    </Component>
  )
}

export default FormBody
